export default "__VITE_ASSET__rV97UFsk__"